// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Ruda&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Libre+Baskerville&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
*
* Autor: Ivan Torres Ibarra
* blog: href="https://torres.neocities.org/
*
*/

/* h1,h2,h3,h4,h5,h6{
	
	font-size: 40px;
	font-style: italic;
} */
.lead {
    margin-bottom: 20px;
    font-size: 16.099999999999998px;
    font-weight: 200;
    line-height: 1.4;
}
/* * {
	padding:0;
	margin:0;
	font-style:italic;
} */

.pal-lado {
	display:flex;
	padding-left:50px;
	padding: 10px;
}

/*
*
* Pagination
*
*/

.pagination {
 display:inline-block;
 padding-left:50px;
 padding: 10px;
 margin:20px 0;
 border-radius:4px
}
.pagination>li {
 display:inline;
 
}
.pagination>li>a,
.pagination>li>span {
 position:relative;
 float:left;
 padding:6px 12px;
 margin-left:-1px;
 line-height:1.428571429;
 text-decoration:none;
 background-color:#fff;
 border:1px solid #ddd;
 color:#232323;
}
.pagination>li:first-child>a,
.pagination>li:first-child>span {
 margin-left:0;
 border-bottom-left-radius:4px;
 border-top-left-radius:4px
}
.pagination>li:last-child>a,
.pagination>li:last-child>span {
 border-top-right-radius:4px;
 border-bottom-right-radius:4px
}
.pagination>li>a:hover,
.pagination>li>span:hover,
.pagination>li>a:focus,
.pagination>li>span:focus {
 background-color:#eee
}
.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
 z-index:2;
 color:#fff;
 cursor:default;
 background-color:#428bca;
 border-color:#428bca
}
.pagination>.disabled>span,
.pagination>.disabled>span:hover,
.pagination>.disabled>span:focus,
.pagination>.disabled>a,
.pagination>.disabled>a:hover,
.pagination>.disabled>a:focus {
 color:#999;
 cursor:not-allowed;
 background-color:#fff;
 border-color:#ddd
}
.pagination-lg>li>a,
.pagination-lg>li>span {
 padding:10px 16px;
 font-size:18px
}
.pagination-lg>li:first-child>a,
.pagination-lg>li:first-child>span {
 border-bottom-left-radius:6px;
 border-top-left-radius:6px
}
.pagination-lg>li:last-child>a,
.pagination-lg>li:last-child>span {
 border-top-right-radius:6px;
 border-bottom-right-radius:6px
}
.pagination-sm>li>a,
.pagination-sm>li>span {
 padding:5px 10px;
 font-size:12px
}
.pagination-sm>li:first-child>a,
.pagination-sm>li:first-child>span {
 border-bottom-left-radius:3px;
 border-top-left-radius:3px
}
.pagination-sm>li:last-child>a,
.pagination-sm>li:last-child>span {
 border-top-right-radius:3px;
 border-bottom-right-radius:3px
}

/*
*
* Fin de Pagination
*
*/

/*
*
* Pagination
*
*/

.pagination-2 {
	display:inline-block;
	padding: 10px;
	padding-left: 5px;
	margin:20px 0;
	border-radius:4px;
    border-radius:50px;
}
.pagination-2>li {
	display:inline;
}
.pagination-2>li>a,
.pagination-2>li>span {
	position:relative;
	float:left;
	padding:6px 12px;
	margin-left:-1px;
	line-height:1.428571429;
	text-decoration:none;
font-size: 8px;
}
.display-paginador-mini .pagination-2>li>a,
.pagination-2>li>span {
	position:relative;
	float:left;
	padding:0px 7px !important;
	margin-left:-1px;
	line-height:1.428571429;
	text-decoration:none;

}
.pagination-2>li:first-child>a,
.pagination-2>li:first-child>span {
	margin-left:0;
	border-bottom-left-radius:15px;
	border-top-left-radius:15px;
}
.pagination-2>li:last-child>a,
.pagination-2>li:last-child>span {
	border-top-right-radius:15px;
	border-bottom-right-radius:15epx;
}
.pagination-2>li>a:hover,
.pagination-2>li>span:hover,
.pagination-2>li>a:focus,
.pagination-2>li>span:focus {
	background-color:var(--hover-color);
	color: var(--txt-color);
    border-radius: 50%;
}
.pagination-2>.active>a,
.pagination-2>.active>span,
.pagination-2>.active>a:hover,
.pagination-2>.active>span:hover,
.pagination-2>.active>a:focus,
.pagination-2>.active>span:focus {
	z-index:2;
	color:#323232;
	cursor:pointer;
	background-color:#ccc;
	border-color:#428bca
}
.pagination-2>.disabled>span,
.pagination-2>.disabled>span:hover,
.pagination-2>.disabled>span:focus,
.pagination-2>.disabled>a,
.pagination-2>.disabled>a:hover,
.pagination-2>.disabled>a:focus {
	color:#999;
	cursor:not-allowed;
	background-color:#232323;
	border-color:#ddd;

}
.pagination-2-lg>li>a,
.pagination-2-lg>li>span {
	padding:10px 16px;
	font-size:18px;
	color: #f5f5f5;
}
.pagination-2-lg>li:first-child>a,
.pagination-2-lg>li:first-child>span {
	border-bottom-left-radius:6px;
	border-top-left-radius:6px;
	color: #f5f5f5;
}
.pagination-2-lg>li:last-child>a,
.pagination-2-lg>li:last-child>span {
	border-top-right-radius:6px;
	border-bottom-right-radius:6px;
	color: #f5f5f5;
}
.pagination-2-sm>li>a,
.pagination-2-sm>li>span {
	padding:5px 10px;
	font-size:12px
}
.pagination-2-sm>li:first-child>a,
.pagination-2-sm>li:first-child>span {
	border-bottom-left-radius:3px;
	border-top-left-radius:3px;
	color: #f5f5f5;
}
.pagination-2-sm>li:last-child>a,
.pagination-2-sm>li:last-child>span {
	border-top-right-radius:3px;
	border-bottom-right-radius:3px;
	color: #f5f5f5;
}


/*
*
* Fin de Pagination
*
*/

/*
*
* Pagination
*
*/

.pagina-radius {
	display:inline-block;
	padding: 5px;
	padding-left:5px;
	margin:20px 0;
	border-radius:50px;
}
.pagina-radius>li {
	display:inline;
	border-radius:50px;
}
.pagina-radius>li>a,
.pagina-radius>li>span {
	position:relative;
	float:left;
	padding:6px 12px;
	margin-left:-1px;
	line-height:1.428571429;
	text-decoration:none;
	border-radius:50px;

}
.display-paginador-mini .pagina-radius>li>a,
.pagina-radius>li>span {
	position:relative;
	float:left;
	padding:0px 7px;
	margin-left:-1px;
	line-height:1.428571429;
	text-decoration:none;
	border-radius:50px;

}
.pagina-radius>li:first-child>a,
.pagina-radius>li:first-child>span {
	margin-left:0;
	border-bottom-left-radius:4px;
	border-top-left-radius:4px;

}
.pagina-radius>li:last-child>a,
.pagina-radius>li:last-child>span {
	border-top-right-radius:4px;
	border-bottom-right-radius:4px;
}
.pagina-radius>li>a:hover,
.pagina-radius>li>span:hover,
.pagina-radius>li>a:focus,
.pagina-radius>li>span:focus {
	background-color:#ccc;
	color: #323232;
	border-radius:50px;
}
.pagina-radius>.active>a,
.pagina-radius>.active>span,
.pagina-radius>.active>a:hover,
.pagina-radius>.active>span:hover,
.pagina-radius>.active>a:focus,
.pagina-radius>.active>span:focus {
	z-index:2;
	color:#323232;
	cursor:pointer;
	background-color:#ccc;
	border-color:#428bca
}
.pagina-radius>.disabled>span,
.pagina-radius>.disabled>span:hover,
.pagina-radius>.disabled>span:focus,
.pagina-radius>.disabled>a,
.pagina-radius>.disabled>a:hover,
.pagina-radius>.disabled>a:focus {
	color:#999;
	cursor:not-allowed;
	background-color:#232323;
	border-color:#ddd;

}
.pagina-radius-lg>li>a,
.pagina-radius-lg>li>span {
	padding:10px 16px;
	font-size:18px;
	color: #f5f5f5;
}
.pagina-radius-lg>li:first-child>a,
.pagina-radius-lg>li:first-child>span {
	border-bottom-left-radius:6px;
	border-top-left-radius:6px;
	color: #f5f5f5;
}
.pagina-radius-lg>li:last-child>a,
.pagina-radius-lg>li:last-child>span {
	border-top-right-radius:6px;
	border-bottom-right-radius:6px;
	color: #f5f5f5;
}
.pagina-radius-sm>li>a,
.pagina-radius-sm>li>span {
	padding:5px 10px;
	font-size:12px
}
.pagina-radius-sm>li:first-child>a,
.pagina-radius-sm>li:first-child>span {
	border-bottom-left-radius:3px;
	border-top-left-radius:3px;
	color: #f5f5f5;
}
.pagina-radius-sm>li:last-child>a,
.pagina-radius-sm>li:last-child>span {
	border-top-right-radius:3px;
	border-bottom-right-radius:3px;
	color: #f5f5f5;
}


/*
*
* Fin de Pagination
*
*/

/*
*
* Temas para Pagination
*
*/


.tema-dark {
	/* background: #232323; */
    background-color: #28282878;
}

.font-dark {
	/* color: #666 */
    color: var(--white-color);
}

.tema-grey {
	background: #666;
}

.font-grey {
	color: var(--txt-color)
}

.tema-orange {
	background: rgb(186, 74, 0);
}

.font-orange {
	color: #f5f5f5
}

.tema-peter {
	background: rgb(27, 79, 114);
}

.font-peter {
	color: #f5f5f5
}

.tema-asbestos {
	background: rgb(66, 73, 73);
}

.font-asbestos {
	color: #f5f5f5
}
/*
* 
* Fin de Temas para Pagination
*
*/

/*
* 
* pager
*
*/

.pager {
	padding-left:0;
	margin:20px 0;
	text-align:center;
	list-style:none
}
.pager:before,
.pager:after {
	display:table;
	content:" "
}
.pager:after {
	clear:both
}
.pager:before,
.pager:after {
	display:table;
	content:" "
}
.pager:after {
	clear:both
}
.pager li {
	display:inline;
	text-decoration: none;
}
.pager li>a,
.pager li>span {
	display:inline-block;
	padding:5px 14px;
	border:1px solid #ddd;
	border-radius:15px;
	text-decoration: none;
}
.pager li>a:hover,
.pager li>a:focus {
	text-decoration:none;
	background-color:#eee;
	color:#232323;
}
.pager .next>a,
.pager .next>span {
	float:right;
	text-decoration:none;
}
.pager .previous>a,
.pager .previous>span {
	float:left
}
.pager .disabled>a,
.pager .disabled>a:hover,
.pager .disabled>a:focus,
.pager .disabled>span {
	color:#999;
	cursor:not-allowed;
	background-color:#fff;
	text-decoration:none;
}

/*
* 
* Fin de pager
*
*/

.panel-mod {
	        position: relative;
			background: #222;
			color: #ccc;
		}
		.nav-left {
			position: fixed;
			width: 80px;
			height: 100%;
			top: 0;
			left: 0px;
			z-index: 1000;
			overflow: auto;
			background: transparent !important;
			color: #ccc;
		}
		.nav-left ul {
			list-style: none;
			overflow: hidden;
	
		}
		.nav-left li {
			padding: 0px;
			list-style: none;

		}
		.nav-left ul li a {
			padding: 23px;
			display: block;
			margin: 0;
			color: #ccc;
			text-decoration: none;
			list-style: none;
			cursor: pointer;
			transition: .4s;
		}
		.nav-left ul li a:hover {
			background: rgba(255, 255, 255, .5);
			color: #232323;
			transition: .4s;
			/* background-color: var(--second-color);
            color: var(--white-color);
            border-radius: 50%; */
		}

		.nav-left:hover {
			box-shadow: 1px 0px 0px 0px rgba(150,150,150,150.2);
		}
		.nav-left ul li a i {
			color: #f5f5f5;
	        font-size: 1em;
	        margin: 10px;
		}

        .pageSelected{
            background-color: var(--second-color) !important;
            color: var(--white-color);
            border-radius: 50%;
        }

		/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and (max-width: 900px) {
    .pagination>li>a,
	.pagination>li>span{
      padding: 3px 9px;
    }
	.pagination-2 > li > a, .pagination-2 > li > span{
		padding: 3px 9px !important;
	}
	
	
  }
  
  /* ****************************Movil****************************** */
  @media (max-width: 500px) {
	.pagination>li>a,
	.pagination>li>span{
      padding: 2px 7px;
    }
	.pagination-2 > li > a, .pagination-2 > li > span{
		padding: 2px 7px !important;
	}
	
  }`, "",{"version":3,"sources":["webpack://./src/components/generales/styles/Paginador.css"],"names":[],"mappings":"AAAA;;;;;CAKC;;AAKD;;;;GAIG;AACH;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;;;GAIG;;AAEH;CACC,YAAY;CACZ,iBAAiB;CACjB,aAAa;AACd;;AAEA;;;;CAIC;;AAED;CACC,oBAAoB;CACpB,iBAAiB;CACjB,aAAa;CACb,aAAa;CACb;AACD;AACA;CACC,cAAc;;AAEf;AACA;;CAEC,iBAAiB;CACjB,UAAU;CACV,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;CACpB,qBAAqB;CACrB,qBAAqB;CACrB,aAAa;AACd;AACA;;CAEC,aAAa;CACb,6BAA6B;CAC7B;AACD;AACA;;CAEC,2BAA2B;CAC3B;AACD;AACA;;;;CAIC;AACD;AACA;;;;;;CAMC,SAAS;CACT,UAAU;CACV,cAAc;CACd,wBAAwB;CACxB;AACD;AACA;;;;;;CAMC,UAAU;CACV,kBAAkB;CAClB,qBAAqB;CACrB;AACD;AACA;;CAEC,iBAAiB;CACjB;AACD;AACA;;CAEC,6BAA6B;CAC7B;AACD;AACA;;CAEC,2BAA2B;CAC3B;AACD;AACA;;CAEC,gBAAgB;CAChB;AACD;AACA;;CAEC,6BAA6B;CAC7B;AACD;AACA;;CAEC,2BAA2B;CAC3B;AACD;;AAEA;;;;CAIC;;AAED;;;;CAIC;;AAED;CACC,oBAAoB;CACpB,aAAa;CACb,iBAAiB;CACjB,aAAa;CACb,iBAAiB;IACd,kBAAkB;AACtB;AACA;CACC,cAAc;AACf;AACA;;CAEC,iBAAiB;CACjB,UAAU;CACV,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;AACrB,cAAc;AACd;AACA;;CAEC,iBAAiB;CACjB,UAAU;CACV,0BAA0B;CAC1B,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;;AAErB;AACA;;CAEC,aAAa;CACb,8BAA8B;CAC9B,2BAA2B;AAC5B;AACA;;CAEC,4BAA4B;CAC5B,gCAAgC;AACjC;AACA;;;;CAIC,mCAAmC;CACnC,uBAAuB;IACpB,kBAAkB;AACtB;AACA;;;;;;CAMC,SAAS;CACT,aAAa;CACb,cAAc;CACd,qBAAqB;CACrB;AACD;AACA;;;;;;CAMC,UAAU;CACV,kBAAkB;CAClB,wBAAwB;CACxB,iBAAiB;;AAElB;AACA;;CAEC,iBAAiB;CACjB,cAAc;CACd,cAAc;AACf;AACA;;CAEC,6BAA6B;CAC7B,0BAA0B;CAC1B,cAAc;AACf;AACA;;CAEC,2BAA2B;CAC3B,8BAA8B;CAC9B,cAAc;AACf;AACA;;CAEC,gBAAgB;CAChB;AACD;AACA;;CAEC,6BAA6B;CAC7B,0BAA0B;CAC1B,cAAc;AACf;AACA;;CAEC,2BAA2B;CAC3B,8BAA8B;CAC9B,cAAc;AACf;;;AAGA;;;;CAIC;;AAED;;;;CAIC;;AAED;CACC,oBAAoB;CACpB,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;;CAEC,iBAAiB;CACjB,UAAU;CACV,gBAAgB;CAChB,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;CACpB,kBAAkB;;AAEnB;AACA;;CAEC,iBAAiB;CACjB,UAAU;CACV,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;CACpB,kBAAkB;;AAEnB;AACA;;CAEC,aAAa;CACb,6BAA6B;CAC7B,0BAA0B;;AAE3B;AACA;;CAEC,2BAA2B;CAC3B,8BAA8B;AAC/B;AACA;;;;CAIC,qBAAqB;CACrB,cAAc;CACd,kBAAkB;AACnB;AACA;;;;;;CAMC,SAAS;CACT,aAAa;CACb,cAAc;CACd,qBAAqB;CACrB;AACD;AACA;;;;;;CAMC,UAAU;CACV,kBAAkB;CAClB,wBAAwB;CACxB,iBAAiB;;AAElB;AACA;;CAEC,iBAAiB;CACjB,cAAc;CACd,cAAc;AACf;AACA;;CAEC,6BAA6B;CAC7B,0BAA0B;CAC1B,cAAc;AACf;AACA;;CAEC,2BAA2B;CAC3B,8BAA8B;CAC9B,cAAc;AACf;AACA;;CAEC,gBAAgB;CAChB;AACD;AACA;;CAEC,6BAA6B;CAC7B,0BAA0B;CAC1B,cAAc;AACf;AACA;;CAEC,2BAA2B;CAC3B,8BAA8B;CAC9B,cAAc;AACf;;;AAGA;;;;CAIC;;AAED;;;;CAIC;;;AAGD;CACC,yBAAyB;IACtB,2BAA2B;AAC/B;;AAEA;CACC,gBAAgB;IACb,yBAAyB;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;AACD;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC;AACD;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;AACD;AACA;;;;CAIC;;AAED;;;;CAIC;;AAED;CACC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB;AACD;AACA;;CAEC,aAAa;CACb;AACD;AACA;CACC;AACD;AACA;;CAEC,aAAa;CACb;AACD;AACA;CACC;AACD;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;CAEC,oBAAoB;CACpB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;AACtB;AACA;;CAEC,oBAAoB;CACpB,qBAAqB;CACrB,aAAa;AACd;AACA;;CAEC,WAAW;CACX,oBAAoB;AACrB;AACA;;CAEC;AACD;AACA;;;;CAIC,UAAU;CACV,kBAAkB;CAClB,qBAAqB;CACrB,oBAAoB;AACrB;;AAEA;;;;CAIC;;AAED;SACS,kBAAkB;GACxB,gBAAgB;GAChB,WAAW;EACZ;EACA;GACC,eAAe;GACf,WAAW;GACX,YAAY;GACZ,MAAM;GACN,SAAS;GACT,aAAa;GACb,cAAc;GACd,kCAAkC;GAClC,WAAW;EACZ;EACA;GACC,gBAAgB;GAChB,gBAAgB;;EAEjB;EACA;GACC,YAAY;GACZ,gBAAgB;;EAEjB;EACA;GACC,aAAa;GACb,cAAc;GACd,SAAS;GACT,WAAW;GACX,qBAAqB;GACrB,gBAAgB;GAChB,eAAe;GAEf,eAAe;EAChB;EACA;GACC,mCAAmC;GACnC,cAAc;GAEd,eAAe;GACf;;iCAE8B;EAC/B;;EAEA;GAGC,mDAAmD;EACpD;EACA;GACC,cAAc;SACR,cAAc;SACd,YAAY;EACnB;;QAEM;YACI,gDAAgD;YAChD,yBAAyB;YACzB,kBAAkB;QACtB;;EAEN,gFAAgF;AAClF;IACI;;MAEE,gBAAgB;IAClB;CACH;EACC,2BAA2B;CAC5B;;;EAGC;;EAEA,oEAAoE;EACpE;CACD;;MAEK,gBAAgB;IAClB;CACH;EACC,2BAA2B;CAC5B;;EAEC","sourcesContent":["/*\r\n*\r\n* Autor: Ivan Torres Ibarra\r\n* blog: href=\"https://torres.neocities.org/\r\n*\r\n*/\r\n\r\n@import url('https://fonts.googleapis.com/css?family=Ruda&display=swap');\r\n@import url('https://fonts.googleapis.com/css?family=Libre+Baskerville&display=swap');\r\n\r\n/* h1,h2,h3,h4,h5,h6{\r\n\t\r\n\tfont-size: 40px;\r\n\tfont-style: italic;\r\n} */\r\n.lead {\r\n    margin-bottom: 20px;\r\n    font-size: 16.099999999999998px;\r\n    font-weight: 200;\r\n    line-height: 1.4;\r\n}\r\n/* * {\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tfont-style:italic;\r\n} */\r\n\r\n.pal-lado {\r\n\tdisplay:flex;\r\n\tpadding-left:50px;\r\n\tpadding: 10px;\r\n}\r\n\r\n/*\r\n*\r\n* Pagination\r\n*\r\n*/\r\n\r\n.pagination {\r\n display:inline-block;\r\n padding-left:50px;\r\n padding: 10px;\r\n margin:20px 0;\r\n border-radius:4px\r\n}\r\n.pagination>li {\r\n display:inline;\r\n \r\n}\r\n.pagination>li>a,\r\n.pagination>li>span {\r\n position:relative;\r\n float:left;\r\n padding:6px 12px;\r\n margin-left:-1px;\r\n line-height:1.428571429;\r\n text-decoration:none;\r\n background-color:#fff;\r\n border:1px solid #ddd;\r\n color:#232323;\r\n}\r\n.pagination>li:first-child>a,\r\n.pagination>li:first-child>span {\r\n margin-left:0;\r\n border-bottom-left-radius:4px;\r\n border-top-left-radius:4px\r\n}\r\n.pagination>li:last-child>a,\r\n.pagination>li:last-child>span {\r\n border-top-right-radius:4px;\r\n border-bottom-right-radius:4px\r\n}\r\n.pagination>li>a:hover,\r\n.pagination>li>span:hover,\r\n.pagination>li>a:focus,\r\n.pagination>li>span:focus {\r\n background-color:#eee\r\n}\r\n.pagination>.active>a,\r\n.pagination>.active>span,\r\n.pagination>.active>a:hover,\r\n.pagination>.active>span:hover,\r\n.pagination>.active>a:focus,\r\n.pagination>.active>span:focus {\r\n z-index:2;\r\n color:#fff;\r\n cursor:default;\r\n background-color:#428bca;\r\n border-color:#428bca\r\n}\r\n.pagination>.disabled>span,\r\n.pagination>.disabled>span:hover,\r\n.pagination>.disabled>span:focus,\r\n.pagination>.disabled>a,\r\n.pagination>.disabled>a:hover,\r\n.pagination>.disabled>a:focus {\r\n color:#999;\r\n cursor:not-allowed;\r\n background-color:#fff;\r\n border-color:#ddd\r\n}\r\n.pagination-lg>li>a,\r\n.pagination-lg>li>span {\r\n padding:10px 16px;\r\n font-size:18px\r\n}\r\n.pagination-lg>li:first-child>a,\r\n.pagination-lg>li:first-child>span {\r\n border-bottom-left-radius:6px;\r\n border-top-left-radius:6px\r\n}\r\n.pagination-lg>li:last-child>a,\r\n.pagination-lg>li:last-child>span {\r\n border-top-right-radius:6px;\r\n border-bottom-right-radius:6px\r\n}\r\n.pagination-sm>li>a,\r\n.pagination-sm>li>span {\r\n padding:5px 10px;\r\n font-size:12px\r\n}\r\n.pagination-sm>li:first-child>a,\r\n.pagination-sm>li:first-child>span {\r\n border-bottom-left-radius:3px;\r\n border-top-left-radius:3px\r\n}\r\n.pagination-sm>li:last-child>a,\r\n.pagination-sm>li:last-child>span {\r\n border-top-right-radius:3px;\r\n border-bottom-right-radius:3px\r\n}\r\n\r\n/*\r\n*\r\n* Fin de Pagination\r\n*\r\n*/\r\n\r\n/*\r\n*\r\n* Pagination\r\n*\r\n*/\r\n\r\n.pagination-2 {\r\n\tdisplay:inline-block;\r\n\tpadding: 10px;\r\n\tpadding-left: 5px;\r\n\tmargin:20px 0;\r\n\tborder-radius:4px;\r\n    border-radius:50px;\r\n}\r\n.pagination-2>li {\r\n\tdisplay:inline;\r\n}\r\n.pagination-2>li>a,\r\n.pagination-2>li>span {\r\n\tposition:relative;\r\n\tfloat:left;\r\n\tpadding:6px 12px;\r\n\tmargin-left:-1px;\r\n\tline-height:1.428571429;\r\n\ttext-decoration:none;\r\nfont-size: 8px;\r\n}\r\n.display-paginador-mini .pagination-2>li>a,\r\n.pagination-2>li>span {\r\n\tposition:relative;\r\n\tfloat:left;\r\n\tpadding:0px 7px !important;\r\n\tmargin-left:-1px;\r\n\tline-height:1.428571429;\r\n\ttext-decoration:none;\r\n\r\n}\r\n.pagination-2>li:first-child>a,\r\n.pagination-2>li:first-child>span {\r\n\tmargin-left:0;\r\n\tborder-bottom-left-radius:15px;\r\n\tborder-top-left-radius:15px;\r\n}\r\n.pagination-2>li:last-child>a,\r\n.pagination-2>li:last-child>span {\r\n\tborder-top-right-radius:15px;\r\n\tborder-bottom-right-radius:15epx;\r\n}\r\n.pagination-2>li>a:hover,\r\n.pagination-2>li>span:hover,\r\n.pagination-2>li>a:focus,\r\n.pagination-2>li>span:focus {\r\n\tbackground-color:var(--hover-color);\r\n\tcolor: var(--txt-color);\r\n    border-radius: 50%;\r\n}\r\n.pagination-2>.active>a,\r\n.pagination-2>.active>span,\r\n.pagination-2>.active>a:hover,\r\n.pagination-2>.active>span:hover,\r\n.pagination-2>.active>a:focus,\r\n.pagination-2>.active>span:focus {\r\n\tz-index:2;\r\n\tcolor:#323232;\r\n\tcursor:pointer;\r\n\tbackground-color:#ccc;\r\n\tborder-color:#428bca\r\n}\r\n.pagination-2>.disabled>span,\r\n.pagination-2>.disabled>span:hover,\r\n.pagination-2>.disabled>span:focus,\r\n.pagination-2>.disabled>a,\r\n.pagination-2>.disabled>a:hover,\r\n.pagination-2>.disabled>a:focus {\r\n\tcolor:#999;\r\n\tcursor:not-allowed;\r\n\tbackground-color:#232323;\r\n\tborder-color:#ddd;\r\n\r\n}\r\n.pagination-2-lg>li>a,\r\n.pagination-2-lg>li>span {\r\n\tpadding:10px 16px;\r\n\tfont-size:18px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagination-2-lg>li:first-child>a,\r\n.pagination-2-lg>li:first-child>span {\r\n\tborder-bottom-left-radius:6px;\r\n\tborder-top-left-radius:6px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagination-2-lg>li:last-child>a,\r\n.pagination-2-lg>li:last-child>span {\r\n\tborder-top-right-radius:6px;\r\n\tborder-bottom-right-radius:6px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagination-2-sm>li>a,\r\n.pagination-2-sm>li>span {\r\n\tpadding:5px 10px;\r\n\tfont-size:12px\r\n}\r\n.pagination-2-sm>li:first-child>a,\r\n.pagination-2-sm>li:first-child>span {\r\n\tborder-bottom-left-radius:3px;\r\n\tborder-top-left-radius:3px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagination-2-sm>li:last-child>a,\r\n.pagination-2-sm>li:last-child>span {\r\n\tborder-top-right-radius:3px;\r\n\tborder-bottom-right-radius:3px;\r\n\tcolor: #f5f5f5;\r\n}\r\n\r\n\r\n/*\r\n*\r\n* Fin de Pagination\r\n*\r\n*/\r\n\r\n/*\r\n*\r\n* Pagination\r\n*\r\n*/\r\n\r\n.pagina-radius {\r\n\tdisplay:inline-block;\r\n\tpadding: 5px;\r\n\tpadding-left:5px;\r\n\tmargin:20px 0;\r\n\tborder-radius:50px;\r\n}\r\n.pagina-radius>li {\r\n\tdisplay:inline;\r\n\tborder-radius:50px;\r\n}\r\n.pagina-radius>li>a,\r\n.pagina-radius>li>span {\r\n\tposition:relative;\r\n\tfloat:left;\r\n\tpadding:6px 12px;\r\n\tmargin-left:-1px;\r\n\tline-height:1.428571429;\r\n\ttext-decoration:none;\r\n\tborder-radius:50px;\r\n\r\n}\r\n.display-paginador-mini .pagina-radius>li>a,\r\n.pagina-radius>li>span {\r\n\tposition:relative;\r\n\tfloat:left;\r\n\tpadding:0px 7px;\r\n\tmargin-left:-1px;\r\n\tline-height:1.428571429;\r\n\ttext-decoration:none;\r\n\tborder-radius:50px;\r\n\r\n}\r\n.pagina-radius>li:first-child>a,\r\n.pagina-radius>li:first-child>span {\r\n\tmargin-left:0;\r\n\tborder-bottom-left-radius:4px;\r\n\tborder-top-left-radius:4px;\r\n\r\n}\r\n.pagina-radius>li:last-child>a,\r\n.pagina-radius>li:last-child>span {\r\n\tborder-top-right-radius:4px;\r\n\tborder-bottom-right-radius:4px;\r\n}\r\n.pagina-radius>li>a:hover,\r\n.pagina-radius>li>span:hover,\r\n.pagina-radius>li>a:focus,\r\n.pagina-radius>li>span:focus {\r\n\tbackground-color:#ccc;\r\n\tcolor: #323232;\r\n\tborder-radius:50px;\r\n}\r\n.pagina-radius>.active>a,\r\n.pagina-radius>.active>span,\r\n.pagina-radius>.active>a:hover,\r\n.pagina-radius>.active>span:hover,\r\n.pagina-radius>.active>a:focus,\r\n.pagina-radius>.active>span:focus {\r\n\tz-index:2;\r\n\tcolor:#323232;\r\n\tcursor:pointer;\r\n\tbackground-color:#ccc;\r\n\tborder-color:#428bca\r\n}\r\n.pagina-radius>.disabled>span,\r\n.pagina-radius>.disabled>span:hover,\r\n.pagina-radius>.disabled>span:focus,\r\n.pagina-radius>.disabled>a,\r\n.pagina-radius>.disabled>a:hover,\r\n.pagina-radius>.disabled>a:focus {\r\n\tcolor:#999;\r\n\tcursor:not-allowed;\r\n\tbackground-color:#232323;\r\n\tborder-color:#ddd;\r\n\r\n}\r\n.pagina-radius-lg>li>a,\r\n.pagina-radius-lg>li>span {\r\n\tpadding:10px 16px;\r\n\tfont-size:18px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagina-radius-lg>li:first-child>a,\r\n.pagina-radius-lg>li:first-child>span {\r\n\tborder-bottom-left-radius:6px;\r\n\tborder-top-left-radius:6px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagina-radius-lg>li:last-child>a,\r\n.pagina-radius-lg>li:last-child>span {\r\n\tborder-top-right-radius:6px;\r\n\tborder-bottom-right-radius:6px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagina-radius-sm>li>a,\r\n.pagina-radius-sm>li>span {\r\n\tpadding:5px 10px;\r\n\tfont-size:12px\r\n}\r\n.pagina-radius-sm>li:first-child>a,\r\n.pagina-radius-sm>li:first-child>span {\r\n\tborder-bottom-left-radius:3px;\r\n\tborder-top-left-radius:3px;\r\n\tcolor: #f5f5f5;\r\n}\r\n.pagina-radius-sm>li:last-child>a,\r\n.pagina-radius-sm>li:last-child>span {\r\n\tborder-top-right-radius:3px;\r\n\tborder-bottom-right-radius:3px;\r\n\tcolor: #f5f5f5;\r\n}\r\n\r\n\r\n/*\r\n*\r\n* Fin de Pagination\r\n*\r\n*/\r\n\r\n/*\r\n*\r\n* Temas para Pagination\r\n*\r\n*/\r\n\r\n\r\n.tema-dark {\r\n\t/* background: #232323; */\r\n    background-color: #28282878;\r\n}\r\n\r\n.font-dark {\r\n\t/* color: #666 */\r\n    color: var(--white-color);\r\n}\r\n\r\n.tema-grey {\r\n\tbackground: #666;\r\n}\r\n\r\n.font-grey {\r\n\tcolor: var(--txt-color)\r\n}\r\n\r\n.tema-orange {\r\n\tbackground: rgb(186, 74, 0);\r\n}\r\n\r\n.font-orange {\r\n\tcolor: #f5f5f5\r\n}\r\n\r\n.tema-peter {\r\n\tbackground: rgb(27, 79, 114);\r\n}\r\n\r\n.font-peter {\r\n\tcolor: #f5f5f5\r\n}\r\n\r\n.tema-asbestos {\r\n\tbackground: rgb(66, 73, 73);\r\n}\r\n\r\n.font-asbestos {\r\n\tcolor: #f5f5f5\r\n}\r\n/*\r\n* \r\n* Fin de Temas para Pagination\r\n*\r\n*/\r\n\r\n/*\r\n* \r\n* pager\r\n*\r\n*/\r\n\r\n.pager {\r\n\tpadding-left:0;\r\n\tmargin:20px 0;\r\n\ttext-align:center;\r\n\tlist-style:none\r\n}\r\n.pager:before,\r\n.pager:after {\r\n\tdisplay:table;\r\n\tcontent:\" \"\r\n}\r\n.pager:after {\r\n\tclear:both\r\n}\r\n.pager:before,\r\n.pager:after {\r\n\tdisplay:table;\r\n\tcontent:\" \"\r\n}\r\n.pager:after {\r\n\tclear:both\r\n}\r\n.pager li {\r\n\tdisplay:inline;\r\n\ttext-decoration: none;\r\n}\r\n.pager li>a,\r\n.pager li>span {\r\n\tdisplay:inline-block;\r\n\tpadding:5px 14px;\r\n\tborder:1px solid #ddd;\r\n\tborder-radius:15px;\r\n\ttext-decoration: none;\r\n}\r\n.pager li>a:hover,\r\n.pager li>a:focus {\r\n\ttext-decoration:none;\r\n\tbackground-color:#eee;\r\n\tcolor:#232323;\r\n}\r\n.pager .next>a,\r\n.pager .next>span {\r\n\tfloat:right;\r\n\ttext-decoration:none;\r\n}\r\n.pager .previous>a,\r\n.pager .previous>span {\r\n\tfloat:left\r\n}\r\n.pager .disabled>a,\r\n.pager .disabled>a:hover,\r\n.pager .disabled>a:focus,\r\n.pager .disabled>span {\r\n\tcolor:#999;\r\n\tcursor:not-allowed;\r\n\tbackground-color:#fff;\r\n\ttext-decoration:none;\r\n}\r\n\r\n/*\r\n* \r\n* Fin de pager\r\n*\r\n*/\r\n\r\n.panel-mod {\r\n\t        position: relative;\r\n\t\t\tbackground: #222;\r\n\t\t\tcolor: #ccc;\r\n\t\t}\r\n\t\t.nav-left {\r\n\t\t\tposition: fixed;\r\n\t\t\twidth: 80px;\r\n\t\t\theight: 100%;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: 0px;\r\n\t\t\tz-index: 1000;\r\n\t\t\toverflow: auto;\r\n\t\t\tbackground: transparent !important;\r\n\t\t\tcolor: #ccc;\r\n\t\t}\r\n\t\t.nav-left ul {\r\n\t\t\tlist-style: none;\r\n\t\t\toverflow: hidden;\r\n\t\r\n\t\t}\r\n\t\t.nav-left li {\r\n\t\t\tpadding: 0px;\r\n\t\t\tlist-style: none;\r\n\r\n\t\t}\r\n\t\t.nav-left ul li a {\r\n\t\t\tpadding: 23px;\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin: 0;\r\n\t\t\tcolor: #ccc;\r\n\t\t\ttext-decoration: none;\r\n\t\t\tlist-style: none;\r\n\t\t\tcursor: pointer;\r\n\t\t\t-webkit-transition: .4s;\r\n\t\t\ttransition: .4s;\r\n\t\t}\r\n\t\t.nav-left ul li a:hover {\r\n\t\t\tbackground: rgba(255, 255, 255, .5);\r\n\t\t\tcolor: #232323;\r\n\t\t\t-webkit-transition: .4s;\r\n\t\t\ttransition: .4s;\r\n\t\t\t/* background-color: var(--second-color);\r\n            color: var(--white-color);\r\n            border-radius: 50%; */\r\n\t\t}\r\n\r\n\t\t.nav-left:hover {\r\n\t\t\t-webkit-box-shadow: 1px 1px 1px 0px rgba(150,150,150,150.2);\r\n\t\t\t-moz-box-shadow: 1px 1px 1px 0px rgba(150,150,150,150.2);\r\n\t\t\tbox-shadow: 1px 0px 0px 0px rgba(150,150,150,150.2);\r\n\t\t}\r\n\t\t.nav-left ul li a i {\r\n\t\t\tcolor: #f5f5f5;\r\n\t        font-size: 1em;\r\n\t        margin: 10px;\r\n\t\t}\r\n\r\n        .pageSelected{\r\n            background-color: var(--second-color) !important;\r\n            color: var(--white-color);\r\n            border-radius: 50%;\r\n        }\r\n\r\n\t\t/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n    .pagination>li>a,\r\n\t.pagination>li>span{\r\n      padding: 3px 9px;\r\n    }\r\n\t.pagination-2 > li > a, .pagination-2 > li > span{\r\n\t\tpadding: 3px 9px !important;\r\n\t}\r\n\t\r\n\t\r\n  }\r\n  \r\n  /* ****************************Movil****************************** */\r\n  @media (max-width: 500px) {\r\n\t.pagination>li>a,\r\n\t.pagination>li>span{\r\n      padding: 2px 7px;\r\n    }\r\n\t.pagination-2 > li > a, .pagination-2 > li > span{\r\n\t\tpadding: 2px 7px !important;\r\n\t}\r\n\t\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
